export const TEMPLATE_PATH =
  "astera-primarycare-template/Astera_PrimaryCare_Bulk_Upload_Template.csv";
